import React, { memo, useState, useContext } from "react";
import { useDrag } from "react-dnd";
import TripTooltip from "./TripTooltip";
import {textWidth, fitText} from "../../functions/TextUtils";
import moment from "moment";
import __ from "lodash";
import SystemContext from "../../SystemContext";
import { ReactComponent as ChecklistStatusIndicator } from '../../assets/ChecklistStatusIndicator.svg';
import { ReactComponent as ArrowHeadPointer } from '../../assets/ArrowHeadPointer.svg';

const TripSvg = memo((props) => {
  const {trip, size, duration, blockSize, startHour, endHour, changed, bgColor, textColor} = props;
  const startPosInner = (blockSize/60) * trip.outboundTurnaround;
  const sizeInner = (blockSize/60) * duration; 
  const startHourText = `${startHour.utc().format("HH:mm")}`;
  const endHourText = `${endHour.utc().format("HH:mm")}`;
  let destinationAirportCode = trip.diverted && props.hideOffsetBox?trip.diversionDetails?.noteData?.destinationAirportCode||trip.destinationAirportCode:trip.destinationAirportCode;
  let originSize = textWidth({text:`${trip.originAirportCode}`,options: { font: 'verdana', size: 11}});
  let destinationSize = textWidth({text:`${destinationAirportCode}`,options: { font: 'verdana', size: 11}});
  let startHourSize = textWidth({text: `${startHourText}`,options: { font: 'verdana', size: 11}});
  let endHourSize = textWidth({text:`${endHourText}`,options: { font: 'verdana', size: 11}});
  const {fontSize: flightFontSize, textSize:flightSize} = fitText({text:`${trip.airlineCode}${trip.flightNo}`,maxSize:sizeInner - 4, maxFontSize:13, minFontSize:6, options:{ font: 'verdana', bold: true }});

  let flightPos = "50%";
  let flightTextAnchor = "middle";
  
  if (sizeInner < flightSize+originSize+5+destinationSize+5+startHourSize+5+endHourSize+5) {
    startHourSize = 0;
    endHourSize = 0;
  }
  if (sizeInner < flightSize+originSize+5+destinationSize+5) {
    originSize = 0;
    if (sizeInner < flightSize+destinationSize+5) {
      destinationSize = 0;
    } else {
      flightPos = `${startPosInner + 3}px`;
      flightTextAnchor = "left";
    }
  }
  let boxPath = `M0,0L${(sizeInner)},0L${(sizeInner)},23L0,23L0,0Z`;
  let strokeWidth = 0.5;
  let stroke = "rgb(0,0,0)";
  let offsetFill = "rgba(180,180,180,0.5)";
  if (props.tearStart && props.tearEnd) {
    strokeWidth = 1;
    stroke = "rgb(120,0,0)";
    offsetFill = "rgba(180,0,0,0.5)";
    boxPath = `M3,0L${(sizeInner)},0L${(sizeInner - 3)},4L${(sizeInner)},8L${(sizeInner - 3)},12L${(sizeInner)},16,L${(sizeInner - 3)},20,L${(sizeInner)},23,L3,23L0,20L3,16L0,12L3,8L0,4L3,0Z`;
  } else if (props.tearStart) {
    strokeWidth = 1;
    stroke = "rgb(120,0,0)";
    offsetFill = "rgba(180,0,0,0.5)";
    boxPath = `M3,0L${(sizeInner)},0L${(sizeInner)},23L3,23L0,20L3,16L0,12L3,8L0,4L3,0Z`;
  } else if (props.tearEnd) {
    strokeWidth = 1;
    stroke = "rgb(120,0,0)";
    offsetFill = "rgba(180,0,0,0.5)";
    boxPath = `M0,0L${(sizeInner)},0L${(sizeInner - 3)},4L${(sizeInner)},8L${(sizeInner - 3)},12L${(sizeInner)},16,L${(sizeInner - 3)},20,L${(sizeInner)},23,L0,23L0,0Z`;
  }

  let offsetsBoxStyle = {fill: offsetFill, strokeWidth:0.5, stroke: "rgb(0,0,0)"};
  if (props.hideOffsetBox){
    offsetsBoxStyle = {fill: "rgba(180,180,180,0)", strokeWidth:0.5, stroke: "rgba(0,0,0,0)"}
  }

  return ( 
  <div>
    <svg width={size} height={24} viewBox={`0 0 ${size} 24`} version="1.1" style={{fillRule:"evenodd", clipRule:"evenodd", strokeLinejoin:"round", strokeMiterlimit: 2}}>
      <rect width={size} height={24}  style={offsetsBoxStyle} />
      {/* <rect width={sizeInner} height={23} x={startPosInner} y={0.5} style={{fill: bgColor, strokeWidth:0.5, stroke: "rgb(0,0,0)"}} /> */}

      <g transform={`translate(${startPosInner}, 0.5)`}>
        <path d={boxPath} style={{fill: bgColor, strokeWidth, stroke}}/>
      </g>

      <text x={flightPos} y="50%" dominantBaseline="middle" textAnchor={flightTextAnchor} style={{font: `bold ${flightFontSize}px verdana`, fill: textColor}}>{sizeInner > flightSize+4?`${trip.airlineCode}${trip.flightNo}`:''}</text>
      <text x={startPosInner + 3} y="50%" dominantBaseline="middle" textAnchor="left" style={{font: "11px verdana", fill: textColor}}>{originSize > 0?`${trip.originAirportCode}`:''}</text>
      <text x={startPosInner + sizeInner - destinationSize - 3} y="50%" dominantBaseline="middle" textAnchor="right" style={{font: "11px verdana", fill: textColor}}>{destinationSize > 0?`${destinationAirportCode}`:''}</text>
      <text x={startPosInner + originSize + 5} y="50%" dominantBaseline="middle" textAnchor="left" style={{font: "11px verdana", fill: textColor}}>{startHourSize > 0?`${startHourText}`:''}</text>
      <text x={startPosInner + sizeInner - destinationSize - endHourSize - 5} y="50%" dominantBaseline="middle" textAnchor="left" style={{font: "11px verdana", fill: textColor}}>{endHourSize > 0?`${endHourText}`:''}</text>
    </svg>
  </div>     
)})

const StatusIndicator = (props) => {
  const {left, color} = props;

  if (color === "none") {
    return null;
  }
  return (
    <div style={{position: "absolute", top: -4, left}}>
      <ChecklistStatusIndicator style={{fill: `${color||'#ff0000'}`, stroke: "#777777", width: 12, height: 12 }}/>
    </div>
  )
}

const PointerIndicator = (props) => {
  const {left, color} = props;

  if (color === "none") {
    return null;
  }
  return (
    <div style={{position: "absolute", top: 14, left}}>
      <ArrowHeadPointer style={{fill: `${color||'#ff0000'}`, stroke: "#777777", width: 20, height: 20}}/>
    </div>
  )
}

const TripLeg = memo((props) => {

  const {trip, blockSize, editing, canChange, colours, hideOffsetBox, canViewDetails, detailAsPanel, selectedTripLegKey} = props;
  const toolTipPinned = props.toolTipPinned;
  const [toolTipOpen, setToolTipOpen] = useState({open:false});
  const [clicked] = useState(false);

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;

  const toolTipCloseHandler = (e) => {
    setToolTipOpen({open:false});
  }

  const toolTipOpenHandler = () => {
    setToolTipOpen({open:true});
  }

  const handleClick = (e) => {
    // if (e.altKey && !e.shiftKey) {
    //   eventBus.trigger("RouteView.TimeWindow.toggleTripMultiSelect", {trip, editing, canChange, colours, canViewDetails});
    // }
    // if (e.shiftKey && !e.altKey) {
    //   eventBus.trigger("RouteView.TimeWindow.toggleLegMultiSelect", {trip, editing, canChange, colours, canViewDetails});
    // }

    if (detailAsPanel) {
      eventBus.trigger("FlightPlan.showTripDetails", {trip, editing, canChange, colours, canViewDetails});
      eventBus.trigger("RouteView.TimeWindow.TripAction.pointAtTripLeg", {tripLegKey: trip.uuid});
    } else {
      if (!toolTipPinned.current.open) {
        toolTipPinned.current = {...toolTipPinned.current, selectedScreen: "map"};
        setToolTipOpen({open:true});    
      }  
    }
  }

  const startTime = trip.scheduledDepartureTimeUtc;
  const endTime = trip.scheduledArrivalTimeUtc;
  const tripType = trip.type==="EXTERNAL"?"TRIP":trip.type==="SCHEDULED"?"SCHEDULED":"TRIP"; 

  let textColor = "rgba(0,0,0,1)";
  let bgColor = "rgba(31, 216, 21, 0.6)";
  if (trip.withinCurfew) bgColor = "rgba(255,0,0,1)"
  else if (trip.diverted && !hideOffsetBox) bgColor = "rgba(118,71,152,1)" 
  else if (props.changed) bgColor = "rgba(0,255,255,0.75)"
  else if (tripType==="SCHEDULED") bgColor = "rgba(255, 255, 81, 0.75)"
  else if (trip.legType === "FERRY") bgColor = "rgba(143, 255, 94, 1)" 
  else bgColor = "rgba(31, 216, 21, 0.6)";
  const colourRow = __.findIndex(colours, {code: `${tripType} STATUS`});
  if (colours && colourRow > -1) {
    if (!hideOffsetBox && (trip.withinCurfew || trip.diverted)) {
      if (props.changed) {
        textColor = "rgba(0,255,255,1)";
      } else {
        textColor = "rgba(255,255,255,1)";
      }
    } else if (props.changed && trip.tripState !== 'DELETED' && trip.tripState !== 'CANCELLED') {
      const changedColorExists = __.has(colours[colourRow].value, 'CHANGED');   
      if (changedColorExists) {
        bgColor = colours[colourRow].value['CHANGED'];
      }
    } else {
      if (trip.tripState === "DELETED" || trip.tripState === "CANCELLED") {
        textColor = "rgba(0,0,0,0.5)";
      }      
      const statusColorExists = __.has(colours[colourRow].value, trip.tripState);   

      if (statusColorExists && !(trip.legType === "FERRY" && trip.tripState === "SCHEDULED")) {
        bgColor = colours[colourRow].value[trip.tripState];
      } else if (trip.legType !== "FERRY") {
        const defaultColorExists = __.has(colours[colourRow].value, 'DEFAULT');    
        if (defaultColorExists) bgColor = colours[colourRow].value['DEFAULT'];    
      }
    }
  }

  const allowDrag = editing && canChange && (tripType === "SCHEDULED" || (tripType === "TRIP" && (trip.tripState === "SCHEDULED" || trip.tripState === "ESTIMATED")))

  const timelineStartsAt = props.timelineStartsAt;

  const startDate = moment(startTime).startOf('day');
  const startHour = moment(startTime);
  const endHour = moment(endTime);
  const duration = moment(endHour).diff(moment(startHour),'minute');
  const totalDuration = duration + trip.outboundTurnaround + trip.inboundTurnaround;
  const startPos = (blockSize/60) * (moment(startHour).subtract(trip.outboundTurnaround,'minutes').diff(moment(timelineStartsAt),'minute')) + (blockSize<12?0:25);
  const size = (blockSize/60) * totalDuration; 
  const indicatorLeft = (blockSize/60) * (trip.outboundTurnaround + duration); 


  const [{dragging}, dragRef] = useDrag(() => ({
    type: tripType, 
    item: {type: tripType, trip, size, blockSize, startHour, duration, endHour},
    collect: (monitor) => ({
      dragging: monitor.isDragging()
    })
  }), [tripType, trip]);

  const handleContextMenu = (event) => {
    event.preventDefault();
    eventBus.trigger(`RouteView.TimeWindow.TripContextMenu`, {
      trip,
      x: event.clientX,
      y: event.clientY,
    });
  };

  const tripControl = allowDrag?(
    <div ref={dragRef} onClick={handleClick} onContextMenu={handleContextMenu} style={{contentVisibility: "auto", position:"absolute", left: (startPos - props.blockSize), top: 3, height: 32, minHeight: 32, maxHeight: 32, display: "block", width: size, minWidth: size, maxWidth: size, backgroundColor: "rgba(0, 0, 0, 0)", textAlign:"left", marginTop: (props.row * 30)}}>
      <TripSvg trip={trip} size={size} blockSize={props.blockSize} startHour={startHour} duration={duration} endHour={endHour} changed={props.changed} bgColor={bgColor} textColor={textColor} tearStart={props.tearStart} tearEnd={props.tearEnd} hideOffsetBox={props.hideOffsetBox}/>
      {selectedTripLegKey === trip.uuid
        ?
          <PointerIndicator left={indicatorLeft - props.blockSize / 60 * duration / 2 - 9} color={"orange"}/>
        :null}
    </div>
  ):(
    <div id={trip.uuid} onClick={handleClick} onContextMenu={handleContextMenu} style={{contentVisibility: "auto", position:"absolute", left: (startPos - props.blockSize), top: 3, height: 34, minHeight: 34, maxHeight: 34, display: "block", width: size, minWidth: size, maxWidth: size, backgroundColor: "rgba(0, 0, 0, 0)", textAlign:"left", marginTop: ((props.row * 30) - (props.offsetTop?props.offsetTop:0))}}>
      <TripSvg trip={trip} size={size} blockSize={props.blockSize} startHour={startHour} duration={duration} endHour={endHour} bgColor={bgColor} textColor={textColor} tearStart={props.tearStart} tearEnd={props.tearEnd} hideOffsetBox={props.hideOffsetBox}/>
      {trip.indicatorColor !== 'none' && tripType !== "SCHEDULED" && canViewDetails?
        <StatusIndicator left={indicatorLeft - 9} color={trip.indicatorStatus}/>
      :null}
      {selectedTripLegKey === trip.uuid?
        <PointerIndicator left={indicatorLeft - props.blockSize / 60 * duration / 2 - 9} color={"orange"}/>
      :null}
    </div>
  );

  if (!detailAsPanel && (toolTipOpen.open || (toolTipPinned.current?.open && toolTipPinned.current?.uuid===trip.uuid))) {
    return (
      <TripTooltip style={{height: 'calc(100vh - 230px)', maxHeight: 'calc(100vh - 230px)'}} toolTipPinned={toolTipPinned} tripData={trip} onClose={toolTipCloseHandler} editing={editing} canChange={canChange} colours={colours} canViewDetails={canViewDetails}>
        {tripControl}
      </TripTooltip>
    )
  }

  return (
    <>{tripControl}</>
  )
})

export {
  TripLeg as default,
  TripSvg
};